import columns from '../../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Operator', 'originImpc.operator'),
        new TextColumn('Code', 'originImpc.code'),
      ],
    },
    {
      Header: 'Destination IMPC',
      columns: [
        new TextColumn('Operator', 'destinationImpc.operator'),
        new TextColumn('Code', 'destinationImpc.code'),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predes.despatchId').withWidth(210)),
        new DateTimeColumn('Despatch closed', 'predes.despatchCloseDate'),
        new DateTimeColumn('Planned departure', 'predes.plannedDepartureDate'),
      ],
    },
    {
      Header: 'Planned departure - despatch closed',
      columns: [
        new NonZeroNumberColumn('d', 'predesVsPlanning.missedDay'),
        new NonZeroNumberColumn('h', 'predesVsPlanning.missedHour'),
        new NonZeroNumberColumn('m', 'predesVsPlanning.missedMinute'),
      ],
    },
  ];
};
